// Reference:
// * https://github.com/epicweb-dev/epic-stack/blob/88ee7cf59dcce3e9269b77bb9eea552d5260776d/app/utils/nonce-provider.ts

import { createContext, useContext } from "react";

const NonceContext = createContext<string>("");

export const NonceProvider = NonceContext.Provider;

export const useNonce = () => useContext(NonceContext);
